const hogs = [
  {
    name: "Babe",
    specialty: "Being incredibly cute",
    greased: false,
    weight: 2.0,
    "highest medal achieved": "bronze",
    image:
      "https://raw.githubusercontent.com/learn-co-curriculum/react-hooks-hogwild/master/public/images/babe.jpg",
  },
  {
    name: "Porkchop",
    specialty: "Making friends",
    greased: true,
    weight: 1.6,
    "highest medal achieved": "silver",
    image:
      "https://raw.githubusercontent.com/learn-co-curriculum/react-hooks-hogwild/master/public/images/porkchop.jpg",
  },
  {
    name: "Cherub",
    specialty: "Flying",
    greased: false,
    weight: 0.7,
    "highest medal achieved": "gold",
    image:
      "https://raw.githubusercontent.com/learn-co-curriculum/react-hooks-hogwild/master/public/images/cherub.jpg",
  },
  {
    name: "Piggy smalls",
    specialty: "Rapping",
    greased: true,
    weight: 5.1,
    "highest medal achieved": "platinum",
    image:
      "https://raw.githubusercontent.com/learn-co-curriculum/react-hooks-hogwild/master/public/images/piggy_smalls.jpg",
  },
  {
    name: "Trouble",
    specialty: "Racing",
    greased: true,
    weight: 1.7,
    "highest medal achieved": "gold",
    image:
      "https://raw.githubusercontent.com/learn-co-curriculum/react-hooks-hogwild/master/public/images/trouble.jpg",
  },
  {
    name: "Piglet",
    specialty: "Bravery and friendship",
    greased: false,
    weight: 2.2,
    "highest medal achieved": "silver",
    image:
      "https://raw.githubusercontent.com/learn-co-curriculum/react-hooks-hogwild/master/public/images/piglet.jpg",
  },
  {
    name: "Peppa",
    specialty: "Being adventurous",
    greased: false,
    weight: 3.7,
    "highest medal achieved": "wood",
    image:
      "https://raw.githubusercontent.com/learn-co-curriculum/react-hooks-hogwild/master/public/images/peppa.jpg",
  },
  {
    name: "Truffle Shuffle",
    specialty: "Peeling oranges",
    greased: true,
    weight: 4.0,
    "highest medal achieved": "gold",
    image:
      "https://raw.githubusercontent.com/learn-co-curriculum/react-hooks-hogwild/master/public/images/truffle_shuffle.jpg",
  },
  {
    name: "Bailey",
    specialty: "Finding truffles",
    greased: false,
    weight: 2.3,
    "highest medal achieved": "bronze",
    image:
      "https://raw.githubusercontent.com/learn-co-curriculum/react-hooks-hogwild/master/public/images/bailey.jpg",
  },
  {
    name: "Galaxy Note",
    specialty: "Cuddling",
    greased: true,
    weight: 1.9,
    "highest medal achieved": "diamond",
    image:
      "https://raw.githubusercontent.com/learn-co-curriculum/react-hooks-hogwild/master/public/images/galaxy_note.jpg",
  },
  {
    name: "Leggo My Eggo",
    specialty: "Babysitting",
    greased: true,
    weight: 3.3,
    "highest medal achieved": "platinum",
    image:
      "https://raw.githubusercontent.com/learn-co-curriculum/react-hooks-hogwild/master/public/images/leggo_my_eggo.jpg",
  },
];

export default hogs;
